/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Agroevidence API
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios';
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

export interface InternalFarmCreate {
  id: string;
  countryCode: string;
  userId: string;
}

export interface FarmUserTo {
  farmId: string;
  userId: string;
  email: string;
}

export interface InternalFarmUser {
  userId: string;
}

export interface InternalFarm {
  id: string;
  countryCode: string;
}

type GetFarmUsersParamsTSMorphBase = {
farmIds: string;
}

export type GetFarmUsersParams = Omit<GetFarmUsersParamsTSMorphBase, "farmIds">;;

export type AddFarmUserParams = {
farmIds: string;
'user-id': string;
};

export type DeleteFarmUserParams = {
farmIds: string;
'user-id': string;
};

type GetInternalFarmUsersParamsTSMorphBase = {
farmIds: string;
}

export type GetInternalFarmUsersParams = Omit<GetInternalFarmUsersParamsTSMorphBase, "farmIds">;;

export type GetFarmsByUserIdParams = {
'user-id': string;
};

/**
 * Creates a new farm with the provided information
 * @summary Create a new farm
 */
export const createFarm = <TData = AxiosResponse<null>>(
    internalFarmCreate: InternalFarmCreate, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.FARM_MANAGEMENT_URL}/internal-api/farms`,
      internalFarmCreate,options
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Retrieves all users associated with the specified farm ID
 * @summary Get users for a farm
 */
export const getFarmUsers = <TData = AxiosResponse<FarmUserTo[]>>(
    params: GetFarmUsersParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Adds a user to a farm with the specified IDs
 * @summary Add a user to a farm
 */
export const addFarmUser = <TData = AxiosResponse<FarmUserTo>>(
    params: AddFarmUserParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Removes a user from a farm with the specified IDs
 * @summary Remove a user from a farm
 */
export const deleteFarmUser = <TData = AxiosResponse<null>>(
    params: DeleteFarmUserParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Retrieves all users associated with the specified farm ID
 * @summary Get users for a farm
 */
export const getInternalFarmUsers = <TData = AxiosResponse<InternalFarmUser[]>>(
    params: GetInternalFarmUsersParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.FARM_MANAGEMENT_URL}/internal-api/farms/users/by-farm`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Retrieves all farms associated with the specified user ID
 * @summary Get farms by user ID
 */
export const getFarmsByUserId = <TData = AxiosResponse<InternalFarm[]>>(
    params: GetFarmsByUserIdParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.FARM_MANAGEMENT_URL}/internal-api/farms/by-user`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export type CreateFarmResult = AxiosResponse<null>
export type GetFarmUsersResult = AxiosResponse<FarmUserTo[]>
export type AddFarmUserResult = AxiosResponse<FarmUserTo>
export type DeleteFarmUserResult = AxiosResponse<null>
export type GetInternalFarmUsersResult = AxiosResponse<InternalFarmUser[]>
export type GetFarmsByUserIdResult = AxiosResponse<InternalFarm[]>
